import api from './api';
import type { EmailTemplate, UpdateEmailTemplateData } from '../types';

export const emailTemplateService = {
  async getTemplates(): Promise<EmailTemplate[]> {
    const response = await api.get<EmailTemplate[]>('/company/email-templates');
    return response.data;
  },

  async getTemplateById(id: string): Promise<EmailTemplate> {
    const response = await api.get<EmailTemplate>(`/company/email-templates/${id}`);
    return response.data;
  },

  async updateTemplate(id: string, data: UpdateEmailTemplateData): Promise<EmailTemplate> {
    const response = await api.patch<EmailTemplate>(`/company/email-templates/${id}`, data);
    return response.data;
  },

  async previewTemplate(id: string, sampleData?: Record<string, string>): Promise<string> {
    const response = await api.post<{ html: string }>(`/company/email-templates/${id}/preview`, {
      sampleData,
    });
    return response.data.html;
  },

  async sendTestEmail(id: string, email: string): Promise<void> {
    await api.post(`/company/email-templates/${id}/test`, { email });
  },
};
